<template>
  <div class="pa-6">
    <v-row>
      <v-col cols="12" md="6">
        <v-card outlined flat>
          <v-card-text class="pa-4">
            <h3 class="primary--text mb-4">{{ $t('guest.notifications.title') }}</h3>
            <v-switch
              v-model="sendSpedilinkNotifications"
              color="primary"
              :label="$t('guest.notifications.emailLabel')"
              :loading="loading"
              :disabled="loading || submitLoading"
              hide-details
              class="mt-0"
              @change="save"
            ></v-switch>
            <p class="text-caption grey--text mt-2">{{ $t('guest.notifications.emailDesc') }}</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { getGuestProfile, updateGuestNotificationSettings } from '@/services/guest'

export default {
  name: 'GuestNotifications',
  data () {
    return {
      sendSpedilinkNotifications: false,
      loading: true,
      submitLoading: false
    }
  },
  async created () {
    await this.fetchSettings()
  },
  methods: {
    async fetchSettings () {
      this.loading = true
      try {
        const { data } = await getGuestProfile()
        this.sendSpedilinkNotifications = data.sendSpedilinkNotifications
      } catch (e) {}
      this.loading = false
    },
    async save () {
      this.submitLoading = true
      try {
        await updateGuestNotificationSettings({
          sendSpedilinkNotifications: this.sendSpedilinkNotifications
        })
        await this.$store.dispatch('setSuccessNotification', this.$t('guest.notifications.saved'))
      } catch (e) {
        this.sendSpedilinkNotifications = !this.sendSpedilinkNotifications
      }
      this.submitLoading = false
    }
  }
}
</script>
